import { NgModule } from '@angular/core';
import { VidaAdapterLoginComponent } from './vida-adapter-login.component';
import { HttpService, BaseHttpInterceptor } from './http-service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [VidaAdapterLoginComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [VidaAdapterLoginComponent],
  providers: [HttpService, {
    provide: HTTP_INTERCEPTORS,
    useClass: BaseHttpInterceptor,
    multi: true
  }]
})
export class VidaAdapterLoginModule { }
